import React, { useState } from "react";
import { mapDispatchProps, mapStateToProps } from "../../store/store";
import { connect } from "react-redux";
import { debounce } from "../../helpers/debounce";
import SnsPaymentBills from "../../pages/sns/payments/bills";
import { useLanguage } from '@languages/index';


interface Props {
  className?: string;
  onClick?: any;

  style?: any;
  preferences?: any;
  history?: any;

  showModal?: (params?: any) => void;
  showSheet?: (params?: any) => void;

  closeOverlays?: () => void;
  showOverlays?: (params?: any) => void;
}

const SnsPaymentHistoryItem = (props: Props) => {
  const language = useLanguage();   
  const languageTexts = { ...language.common, ...language.component.snsPaymentHistoryItem };

  const showBills = () => {
    props.closeOverlays();
    debounce(() => {
      props.showOverlays({
        content: () => {
          return <SnsPaymentBills history={props.history} />;
        },
      });
    }, 400);
  };

  return (
    <div className="flex flex-col">
      <div
        className="flex px-5 py-4 flex-row justify-around border-b border-grey-200 cursor-pointer gap-3"
        style={{
          ...{ backgroundColor: "rgba(0, 0, 0, 0.05)" },
          ...props.style,
        }}
        onClick={() => {
          //   toggleAccordion();
        }}
      >
        <span className="text-sm text-start flex-col items-center">
          <div className="flex flex-row">
            <span>{props.history.typeDesc}</span>
          </div>
          {/* <div className="flex flex-row items-center">
            <span className="text-xs opacity-50 cursor-pointer">
              자세히 보기
            </span>
            <ChevronDown size={12} />
          </div> */}
        </span>
        <span className="flex-1 text-base text-right items-center pl-3 tracking-tighter">
          {props.history.createdDate}
          <small
            className="ml-1 text-xs underline opacity-50 cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              showBills();
            }}
          >
            {languageTexts.bills}
          </small>
        </span>
      </div>
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchProps
)(SnsPaymentHistoryItem);
